export enum NEWSLETTER_ACTION {}

export interface Newsletter {
  email: string;
  is_authorized: boolean;
  updated_at: number;
}
